import { createStore, applyMiddleware, compose } from "redux";
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import baseReducer from './reducers';

const middlewares = [thunk];

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['getProfile']
}

const persistedReducer = persistReducer(persistConfig, baseReducer);
const store = createStore(persistedReducer, composeEnhancers(applyMiddleware(...middlewares)));

export const persistor = persistStore(store);

export default store;
